<div class="card">
    <iframe src="https://i.simmer.io/@GreenMachine2o3/killer" style="width:960px;height:600px"></iframe>
</div>